import {ColumnInstance, Row} from 'react-table'
import {KTCardBody} from '../../_metronic/helpers'
import {ColumnHeader} from './ColumnHeader'
import {CustomRow} from './CustomRow'
import {Pagination} from './Pagination'
import {ListLoading} from '../ListLoading'

export type KTableProps = {
  headers: ColumnInstance<any>[]
  rows: Row<any>[]
  getTableProps: () => any
  getTableBodyProps: () => any
  prepareRow: (row: Row<any>) => void
  setItemIdToView?: (id: string) => void
  isLoading: boolean
  pagination?: any
  updateState?: (state: any) => void
}

export const KTable = ({
  headers,
  rows,
  getTableProps,
  getTableBodyProps,
  prepareRow,
  setItemIdToView,
  isLoading,
  pagination,
  updateState,
}: KTableProps) => {
  return (
    <KTCardBody className='py-4'>
      <div className='overflow-x-auto'>
        <table
          id='kt_table_departments'
          className='min-w-full table-auto border-separate border-spacing-y-2 text-sm'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-left text-gray-500 font-bold uppercase text-xs tracking-wider'>
              {headers.map((column: ColumnInstance<any>) => (
                <ColumnHeader key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-700 font-semibold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<any>, i: number) => {
                prepareRow(row)
                return (
                  <CustomRow
                    row={row}
                    setItemIdToView={setItemIdToView}
                    key={`row-${i}-${row.id}`}
                  />
                )
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='flex w-full justify-center items-center text-center py-6 text-gray-400'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {pagination && updateState && (
        <Pagination isLoading={isLoading} pagination={pagination} updateState={updateState} />
      )}
      {isLoading && <ListLoading />}
    </KTCardBody>
  )
}
